import api from "../lib/axios";

const BASE_URL = "/EquipmentCertificate";

export const equipmentCertificateService = {
    
  getAsync: async (certificateNo) => {
    const response = await api.get(
      `${BASE_URL}/get-equipment-certificate/${certificateNo}`,
    );
    return response.data;
  }
};